import { GetUserCultStatusResponse } from '../../types/cults';

export const getUserCultStatusModel = (response: GetUserCultStatusResponse): GetUserCultStatusResponse => response;
